import { ACTIONS, PhlebognadminTypes, } from "../interfaces/actionTypes/GenomicsSampleAccessioning";

type InitialState = {
    pin_code: Array<any>;
    cities: Array<any>;
    areaList: Array<any>;
    agentsList: Array<any>;
    phleboList: Array<any>;
    packageList: Array<any>;
    checkGeoFenceStatus: boolean;
    partnerList: Array<any>;
    couponList: Array<any>;
    createBooking: Object;
    booking: Object;
    todays_positive_calls: Object;
    sampleJourneyComments: Object;
    geoFencesMapMyIndia: Array<any>;
    lead_details: Object;
    leadById: Object;
    leads: Array<any>;
    bookingList: Array<any>;
    mapmyindiaAccessToken: Array<any>;
    comment: any;
    data: any;
    users: any;
    bookingsComment: any;
    lead_id: number;
    displayCities: Array<any>;
    read_call_details: object;
    all_recordings: object;
    whatsappComments: object;
    multiplePackage: Array<any>;
    whatsappCommentsByLead: object;
    additional_booking: object;
    callStats: object;
    complaint: object;
    complaints: object;
    lead_source: any;
    booking_slots: object;
    imagingTimeSlots: Array<any>;
    subCenter: Array<any>;
    search_results: object,
    call_status: object;
    all_lead: object;
    call_transfer: object;
    user_panel: object;
    agentBYUserGroup: object;
    syncData: Object;
    tube_details: Array<any>;
    bookingReceivedPackage: Array<any>;
    smsReportSend: Array<any>;
    loading: boolean;
    sendSMSLink: Array<any>;
    reportDownload: Array<any>;
    reportStatus: Array<any>;
    centerInfo: Array<any>;
    paymentInformation: Array<any>;
    notificationMessage: Array<any>;
    unmaskedNumber: Array<any>;
    sampleHandOverData: Array<any>;
    unregisterBookingStatus: Array<any>;
    additionMember: Array<any>;
    signature: Array<any>;
    qrcode: Array<any>;
    repetedLead: Array<any>;
    packageTubeDetails: Array<any>;
    unregisterBooking: Array<any>;
    riderList: Array<any>;
    bookingByBarcode: Array<any>;
    doctorInfo: Array<any>;
    receivedPackages: Array<any>;
    doctorQual: Array<any>;
    doctorSpec: Array<any>;
    responseRefDoctor: Object;
    refDoctor: Array<any>;
    biomarkerScreening: Array<any>;
    biomarkerUltasound: Array<any>;
    bookingsByCentre: Array<any>;
    tubeByBooking: Array<any>;
    updatebBookingData: Array<any>;
    uploadTrf: Array<any>;
    bookingoverview: Array<any>;




};

const initialState: InitialState = {
    pin_code: [],
    cities: [],
    areaList: [],
    agentsList: [],
    phleboList: [],
    packageList: [],
    partnerList: [],
    couponList: [],
    createBooking: {},
    additional_booking: {},
    booking: {},
    lead_details: {},
    leadById: {},
    multiplePackage: [],
    todays_positive_calls: {},
    sampleJourneyComments: {},
    leads: [],
    unregisterBooking: [],
    unregisterBookingStatus: [],
    bookingList: [],
    comment: {},
    data: {},
    users: {},
    loading: false,
    read_call_details: {},
    all_recordings: {},
    whatsappComments: {},
    whatsappCommentsByLead: {},
    geoFencesMapMyIndia: [],
    callStats: {},
    complaint: {},
    complaints: {},
    bookingsComment: {},
    subCenter: [],
    lead_id: 0,
    lead_source: {},
    booking_slots: {},
    search_results: {},
    call_status: {},
    all_lead: {},
    call_transfer: {},
    agentBYUserGroup: {},
    user_panel: {},
    tube_details: [],
    imagingTimeSlots: [],
    syncData: [],
    bookingReceivedPackage: [],
    smsReportSend: [],
    sendSMSLink: [],
    reportDownload: [],
    displayCities: [],
    reportStatus: [],
    centerInfo: [],
    paymentInformation: [],
    notificationMessage: [],
    unmaskedNumber: [],
    sampleHandOverData: [],
    additionMember: [],
    mapmyindiaAccessToken: [],
    signature: [],
    qrcode: [],
    checkGeoFenceStatus: false,
    repetedLead: [],
    packageTubeDetails: [],
    riderList: [],
    bookingByBarcode: [],
    doctorInfo: [],
    receivedPackages: [],
    doctorSpec: [],
    responseRefDoctor: {},
    doctorQual: [],
    refDoctor: [],
    biomarkerScreening: [],
    biomarkerUltasound: [],
    bookingsByCentre: [],
    tubeByBooking: [],
    updatebBookingData: [],
    uploadTrf: [],
    bookingoverview: [],



};

const CustomerLeadReducer = (state = initialState, action: PhlebognadminTypes) => {
    switch (action.type) {
        case ACTIONS.GET_PIN_CODE:
            return {
                ...state,
                pin_code: action.payload,
                loading: false,
            };
        case ACTIONS.GET_BOOKING_OVERVIEW:
            return {
                ...state,
                bookingoverview: action.payload,
                loading: false,
            };
        case ACTIONS.GET_TUBE_BY_BOOKING:
            return {
                ...state,
                tubeByBooking: action.payload,
                loading: false,
            };
        case ACTIONS.GET_UPLOAD_TRF:
            return {
                ...state,
                uploadTrf: action.payload,
                loading: false,
            };
        case ACTIONS.UPDATE_BOOKING:
            return {
                ...state,
                updatebBookingData: action.payload,
                loading: false,
            };
        case ACTIONS.BOOKING_DATA_RESET:
            return {
                ...state,
                createIMGBooking: {},
                receivedPackages: {},
                updatebBookingData: {},
                tubeByBooking: {},

            };
        case ACTIONS.GET_BOOKINGS_BY_CENTRE:
            return {
                ...state,
                bookingsByCentre: action.payload,
                loading: false,
            };
        case ACTIONS.GET_BIOMARKER_SCREENING:
            return {
                ...state,
                biomarkerScreening: action.payload,
                loading: false,
            };
        case ACTIONS.GET_BIOMARKER_ULTASOUND:
            return {
                ...state,
                biomarkerUltasound: action.payload,
                loading: false,
            };
        case ACTIONS.GET_DOCTOR_SPEC:
            return {
                ...state,
                doctorSpec: action.payload,
                loading: false,
            };
        case ACTIONS.GET_REF_DOCTOR:
            return {
                ...state,
                refDoctor: action.payload,
                loading: false,
            };
        case ACTIONS.REF_DOCTOR_RESET:
            return {
                ...state,
                responseRefDoctor: {},
            };
        case ACTIONS.GET_DOCTOR_QUAL:
            return {
                ...state,
                doctorQual: action.payload,
                loading: false,
            };
        case ACTIONS.POST_REF_DOCTOR:
            return {
                ...state,
                responseRefDoctor: action.payload,
                loading: false,
            };
        case ACTIONS.GET_DOCTOR_INFO_BY_ID:
            return {
                ...state,
                doctorInfo: action.payload,
                loading: false,
            };
        case ACTIONS.UPLOAD_FILE:
            return {
                ...state,
                data: action.payload,
                loading: false,
            };
        case ACTIONS.GET_PHLEBOS:
            return {
                ...state,
                phleboList: action.payload,
                loading: false,
            };
        case ACTIONS.GET_CITIES:
            return {
                ...state,
                cities: action.payload,
                loading: false,
            };
        case ACTIONS.GET_AREA:
            return {
                ...state,
                areaList: action.payload,
                loading: false,
            };
        case ACTIONS.UPDATE_UNREGISTERD_BOOKING_STATUS:
            return {
                ...state,
                unregisterBookingStatus: action.payload,
                loading: false,
            };
        case ACTIONS.GET_POSTIVE_CALLS_COMMENTS:
            return {
                ...state,
                todays_positive_calls: action.payload,
                loading: false,
            };
        case ACTIONS.GET_SAMPLE_JOURNEY_COMMENTS:
            return {
                ...state,
                sampleJourneyComments: action.payload,
                loading: false,
            };
        case ACTIONS.SET_COMMENTS:
            return {
                ...state,
                comment: action.payload,
                loading: false,
            };
        case ACTIONS.ADD_POSTIVE_CALLS_COMMENT:
            return {
                ...state,
                todays_positive_calls: action.payload,
                loading: false,
            };
        case ACTIONS.GET_LEAD_DETAILS:
            return {
                ...state,
                lead_details: action.payload,
                loading: false,
            };
        case ACTIONS.GET_LEADS:
            return {
                ...state,
                leads: action.payload,
                loading: false,
            };
        case ACTIONS.GET_LEAD_BY_ID:
            return {
                ...state,
                leadById: action.payload,
                loading: false,
            };
        case ACTIONS.CHECK_GEOFENCE_AREA_MAMPMYINDIA:
            return {
                ...state,
                geoFencesMapMyIndia: action.payload,
                loading: false,
            };
        case ACTIONS.LEAD_DETAILS_RESET:
            return {
                ...state,
                leadById: {},
                lead_details: {},
                loading: false,
            };
        case ACTIONS.GET_AGENTS:
            return {
                ...state,
                agentsList: action.payload,
                loading: false,
            };
        case ACTIONS.GET_AGENTS_BY_USERGROUP:
            return {
                ...state,
                GET_AGENTS_BY_USERGROUP: action.payload,
                loading: false,
            };
        case ACTIONS.GET_PACKAGES:
            return {
                ...state,
                packageList: action.payload,
                loading: false,
            };
        case ACTIONS.GET_PARTNERS:
            return {
                ...state,
                partnerList: action.payload,
                loading: false,
            };
        case ACTIONS.GET_COUPONS:
            return {
                ...state,
                couponList: action.payload,
                loading: false,
            };
        case ACTIONS.GET_IMAGING_TIMESLOTS:
            return {
                ...state,
                imagingTimeSlots: action.payload,
                loading: false,
            };
        case ACTIONS.CREATE_BOOKING:
            return {
                ...state,
                createBooking: action.payload,
                loading: false,
            };
        case ACTIONS.GET_BOOKING_LIST:
            return {
                ...state,
                bookingList: action.payload,
                loading: false,
            };
        case ACTIONS.GET_BOOKING_BY_ID:
            return {
                ...state,
                booking: action.payload,
                loading: false,
            };
        case ACTIONS.GET_RECEIVED_PACKAGES:
            return {
                ...state,
                receivedPackages: action.payload,
                loading: false,
            };
        case ACTIONS.SET_LOADING:
            return {
                ...state,
                loading: action.payload,
            };
        case ACTIONS.CREATE_CALL:
            return {
                ...state,
                loading: false,
                lead_id: action.payload,
            };
        case ACTIONS.GET_RECORDINGS:
            return {
                ...state,
                all_recordings: action.payload,
                loading: false,
            };
        case ACTIONS.CREATE_ADDITIONAL_BOOKING:
            return {
                ...state,
                additional_booking: action.payload,
                loading: false,
            };
        case ACTIONS.UPDATE_ADDITIONAL_BOOKING:
            return {
                ...state,
                additional_booking: action.payload,
                loading: false,
            };
        case ACTIONS.GET_LEAD_SOURCE:
            return {
                ...state,
                lead_source: action.payload,
                loading: false,
            };
        case ACTIONS.SEARCH_CALL:
            return {
                ...state,
                search_results: action.payload,
                loading: false,
            };
        case ACTIONS.ADD_COMMENT:
            return {
                ...state,
                comments: action.payload,
                loading: false,
            };
        // case ACTIONS.BOOKING_RESET:
        //     return {
        //         ...state,
        //         createBooking: {},
        //         bookingList: [],
        //         loading: false,
        //     };
        case ACTIONS.GET_BOOKINGS_COMMENTS:
            return {
                ...state,
                bookingsComment: action.payload,
                loading: false,
            };
        case ACTIONS.ADD_BOOKINGS_COMMENT:
            return {
                ...state,
                bookingsComment: action.payload,
                loading: false,
            };
        case ACTIONS.GET_MAMPMYINDIA_ACCESS_TOKEN:
            return {
                ...state,
                mapmyindiaAccessToken: action.payload,
                loading: false,
            };
        case ACTIONS.GET_WHATSAPP_COMMENTS:
            return {
                ...state,
                whatsappComments: action.payload,
                loading: false,
            };
        case ACTIONS.GET_DISPLAY_CITIES:
            return {
                ...state,
                displayCities: action.payload,
                loading: false,
            };
        case ACTIONS.GET_WHATSAPP_COMMENTS_BY_LEAD:
            return {
                ...state,
                whatsappCommentsByLead: action.payload,
                loading: false,
            };
        case ACTIONS.SEND_WHATSAPP_COMMENTS:
            return {
                ...state,
                whatsappComments: action.payload,
                loading: false,
            };
        case ACTIONS.GET_CALL_STATS:
            return {
                ...state,
                callStats: action.payload,
                loading: false,
            };
        case ACTIONS.CHECK_GEOFENCE_AREA:
            return {
                ...state,
                checkGeoFenceStatus: action.payload,
                loading: false,
            };
        case ACTIONS.RAISE_COMPLAINT:
            return {
                ...state,
                complaint: action.payload,
                loading: false,
            };
        case ACTIONS.GET_COMPLAINTS:
            return {
                ...state,
                complaints: action.payload,
                loading: false,
            };
        case ACTIONS.ASSIGN_DOCTOR:
            return {
                ...state,
                success: true,
                loading: false,
            };
        case ACTIONS.SEND_FEEDBACK:
            return {
                ...state,
                success: true,
                loading: false,
            };
        case ACTIONS.GET_AVAILABLE_SLOTS:
            return {
                ...state,
                booking_slots: action.payload,
                loading: false,
            };
        case ACTIONS.GET_ALL_LEADS:
            return {
                ...state,
                all_lead: action.payload,
                loading: false,
            };
        case ACTIONS.GET_PANEL_USERS:
            return {
                ...state,
                user_panel: action.payload,
                loading: false,
            };
        case ACTIONS.LEAD_TRANSFER_BY_COMMA:
            return {
                ...state,
                all_lead: action.payload,
                loading: false,
            };
        case ACTIONS.GET_SYNC_DATA:
            return {
                ...state,
                syncData: action.payload,
                loading: false,
            };
        case ACTIONS.GET_SUB_CENTER_INFORMATION:
            return {
                ...state,
                subCenter: action.payload,
                loading: false,
            };
        case ACTIONS.GET_MULTIPLE_PACKAGES:
            return {
                ...state,
                multiplePackage: action.payload,
                loading: false,
            };
        case ACTIONS.GET_TUBE_DETAILS:
            return {
                ...state,
                tube_details: action.payload,
                loading: false,
            };
        case ACTIONS.GET_BOOKING_RECEIVED_PACKAGE:
            return {
                ...state,
                bookingReceivedPackage: action.payload,
                loading: false,
            };
        case ACTIONS.GET_SMS_REPORT_SEND:
            return {
                ...state,
                smsReportSend: action.payload,
                loading: false,
            };
        case ACTIONS.GET_SMS_LINK:
            return {
                ...state,
                sendSMSLink: action.payload,
                loading: false,
            };
        case ACTIONS.GET_REPORT_DOWNLOAD:
            return {
                ...state,
                reportDownload: action.payload,
                loading: false,
            };
        case ACTIONS.GET_REPORT_STATUS:
            return {
                ...state,
                reportStatus: action.payload,
                loading: false,
            };
        case ACTIONS.GET_CENTER_INFORMATION:
            return {
                ...state,
                centerInfo: action.payload,
                loading: false,
            };
        case ACTIONS.GET_PAYMENT_INFORMATION:
            return {
                ...state,
                paymentInformation: action.payload,
                loading: false,
            };
        case ACTIONS.GET_NOTIFICATION_MESSAGE:
            return {
                ...state,
                notificationMessage: action.payload,
                loading: false,
            };
        case ACTIONS.GET_UNMASKED_NUMBER:
            return {
                ...state,
                unmaskedNumber: action.payload,
                loading: false,
            };
        case ACTIONS.GET_SAMPLE_HANDOVER_DATA:
            return {
                ...state,
                sampleHandOverData: action.payload,
                loading: false,
            };
        case ACTIONS.GET_ADDITIONAL_BOOKING:
            return {
                ...state,
                additionMember: action.payload,
                loading: false,
            };
        case ACTIONS.GET_SIGNATURE:
            return {
                ...state,
                signature: action.payload,
                loading: false,
            };
        case ACTIONS.GET_QRCODE_DATA:
            return {
                ...state,
                qrcode: action.payload,
                loading: false,
            };
        case ACTIONS.GET_UNREGISTERD_BOOKING:
            return {
                ...state,
                unregisterBooking: action.payload,
                loading: false,
            };
        case ACTIONS.GET_RIDER_LIST:
            return {
                ...state,
                riderList: action.payload,
                loading: false,
            };
        default:
        case ACTIONS.GET_PACKAGE_TUBE_DETAILS:
            return {
                ...state,
                packageTubeDetails: action.payload,
                loading: false,
            };
        case ACTIONS.GET_BOOKING_BY_BARCODE:
            return {
                ...state,
                bookingByBarcode: action.payload,
                loading: false,
            };
            return state;
    }
};

export default CustomerLeadReducer;
